export const AUDIT_ENTITY_TYPE_OPTIONS = [
    { value: 'ALL', label: 'Todas las entidades' },
    { value: 'TICKET', label: 'Tickets' },
    { value: 'TICKET_FOLLOW', label: 'Seguimientos' },
    { value: 'USER', label: 'Usuarios' },
    { value: 'CUSTOMER', label: 'Clientes' },
    { value: 'PROJECT', label: 'Proyectos' },
    { value: 'GROUP', label: 'Grupos' },
];

export const AUDIT_ACTION_OPTIONS = [
    { value: 'ALL', label: 'Todas las acciones' },
    { value: 'CREATE', label: 'Creación' },
    { value: 'UPDATE', label: 'Actualización' },
    { value: 'DELETE', label: 'Eliminación' },
];

const entityTypeLabelMap = AUDIT_ENTITY_TYPE_OPTIONS.reduce((accumulator, option) => {
    accumulator[option.value] = option.label;
    return accumulator;
}, {});

const actionLabelMap = AUDIT_ACTION_OPTIONS.reduce((accumulator, option) => {
    accumulator[option.value] = option.label;
    return accumulator;
}, {});

export const getAuditEntityTypeLabel = (value = '') => entityTypeLabelMap[String(value || '').toUpperCase()] || 'Registro';
export const getAuditActionLabel = (value = '') => actionLabelMap[String(value || '').toUpperCase()] || 'Acción';

export const getAuditActionTone = (value = '') => {
    const normalized = String(value || '').toUpperCase();

    if (normalized === 'CREATE') {
        return 'success';
    }

    if (normalized === 'DELETE') {
        return 'danger';
    }

    return 'primary';
};

export const formatAuditDate = (value) => {
    if (!value) {
        return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '-';
    }

    return new Intl.DateTimeFormat('es-MX', {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(date);
};

export const formatAuditActorLabel = (auditLog) => {
    if (!auditLog) {
        return 'Usuario no disponible';
    }

    return auditLog?.actorUser?.name || auditLog?.actorName || auditLog?.actorEmail || 'Usuario no disponible';
};

export const formatAuditEntityLabel = (auditLog) => {
    if (!auditLog) {
        return '-';
    }

    const code = String(auditLog?.entityCode || '').trim();
    const name = String(auditLog?.entityName || '').trim();
    if (code && name) {
        return `${code} · ${name}`;
    }

    return code || name || String(auditLog?.entityId || '-');
};

export const stringifyAuditSnapshot = (value) => {
    if (value === null || value === undefined) {
        return 'Sin datos';
    }

    try {
        return JSON.stringify(value, null, 2);
    } catch (_error) {
        return 'No se pudo renderizar el contenido.';
    }
};

export const buildAuditActorOptions = (users = []) => {
    const baseOptions = [{ value: 'ALL', label: 'Todos los actores' }];

    const userOptions = (Array.isArray(users) ? users : []).map((user) => ({
        value: user._id,
        label: user?.name || user?.email || 'Usuario',
    }));

    return [...baseOptions, ...userOptions];
};